<template>
  <b-navbar-nav id="popOverContainer">
    <b-nav-item
      id="alarmsPopTarget"
      v-tooltip="$tc('global.alarm', 2)"
      class="navbar-badge alarm-nav mx-2"
    >
      <i
        class="far fa-bell"
        aria-hidden="true"
      />
      <b-badge class="vt-nav-badge alarms">
        {{ totalElementsStr }}
      </b-badge>
    </b-nav-item>
    <notification-list-popover
      target="alarmsPopTarget"
      :count="count"
      :notifications="notifications"
      :type="NOTIFICATION_TYPE.ALARMS"
      :total-elements="totalElements"
      @reload="loadNotifications"
    />
  </b-navbar-nav>
</template>

<script>
import NotificationListPopover from './NotificationListPopover'
import notificationService from '@/components/NavBar/notifications/services/notificationService'
import { NOTIFICATION_TYPE } from '@/components/NavBar/notifications/constants/notificationTypes'

export default {
    name: 'AlarmListNav',
    components: {
        NotificationListPopover
    },
    data() {
        return {
            isActive: false,
            count: 0,
            notifications: [],
            totalElements: 0
        }
    },
    computed: {
        NOTIFICATION_TYPE() {
            return NOTIFICATION_TYPE
        },
        totalElementsStr() {
            return `${(this.totalElements > 10 ? '10+' : this.totalElements)}`
        }
    },
    mounted() {
        this.loadNotifications()
    },
    methods: {
        showLogoutModal() {
            this.$refs.logoutModal.show()
        },
        async loadNotifications() {
            const params = {
                isAlarm: true,
                size: 10,
                sort: 'timestamp,desc'
            }
            const filterModel = {
                'read': {
                    filterType: 'boolean',
                    type: 'equals',
                    filter: false
                }
            }
            const [err, response] = await this.toCall(notificationService.paginator(filterModel, params))
            if (err) {
                return
            }
            this.notifications = response.content
            this.count = response.numberOfElements
            this.totalElements = response.totalElements
        }
    }
}

</script>

<style scoped lang="scss">

    svg.nav-envelope {
        font-size: 19px;
        width: 19px;
    }

</style>
